module.exports = __webpack_public_path__ + "static/media/empty.9b180de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty.png
// module id = 85
// module chunks = 0